import { Fragment } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import IntroPage from "./pages/intro-page";
import Routers from "./routes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthStaffUserProvider } from "./context/AuthStaffUserContext";

export const queryClient = new QueryClient();
console.log("REACT_APP_SERVER: ", process.env.REACT_APP_SERVER);

function App() {
  return (
    <Fragment>
      <ToastContainer />
      <QueryClientProvider client={queryClient}>
        <AuthStaffUserProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<IntroPage />} />
              <Route path="/:hotelcode/*" element={<Routers />} />
            </Routes>
          </BrowserRouter>
        </AuthStaffUserProvider>
      </QueryClientProvider>
    </Fragment>
  );
}
export default App;
